import * as React from "react";
import * as request from "superagent";
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap,
} from "@material-ui/core/styles/withStyles";

// import { Definition } from "~common/lib/types";
import { APIError } from "~common/lib/types";
import URLManager from "~common/lib/url-manager";
import { Theme } from "@material-ui/core/styles";
import LoadingView from "~common/components/loading-view";

import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@material-ui/core";

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  modalContent: {
    minHeight: 300,
    width: 570,
  },
  modal: {
    minHeight: 300,
    minWidth: 600,
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  title: string;
  templateSelector?: any;
  templateText?: string;
  handleCancel?: Function;
  handleComplete?: Function;
  completeButtonText?: string;
  data?: any;
  // Grid Spacing is the spacing for the grid that will be honored in the form.  Will default to 8
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
}

type State = {
  status: "loading" | "ready" | "error";
  template?: any;
  error?: any;
};

class TemplateDialogForm extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: "loading",
    };
  }

  componentDidMount() {
    if (this.props.templateText) {
      this.setState({
        template: {templateContents: this.props.templateText},
        status: "ready",
      });
    } else if (this.props.templateSelector) {
      request
        .get(
          `/api/portal-templates/select?selector=${URLManager.getQueryStringValue(
            this.props.templateSelector
          )}`
        )
        .then((response) => {
          var templateData: any = response.body;
          request
            .put(`/api/portal-templates/compile`)
            .send({
              template: response.body.templateContents,
              data: this.props.data,
            })
            .then((response: request.Response) => {
              templateData.templateContents = response.body.compiled;
              this.setState({
                template: templateData,
                status: "ready",
              });
            });
        });
    }
  }

  handleCancel = () => {
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  };

  handleComplete = () => {
    if (this.props.handleComplete) {
      this.props.handleComplete();
    }
  };

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const { title, gridSpacing } = this.props;
    const { status, template } = this.state;
    switch (status) {
      default:
        return (
          <Dialog
            className={classes.modal}
            open={true}
            onClose={this.handleCancel}
          >
            <DialogTitle>{(template || {}).title || title}</DialogTitle>
            <DialogContent style={{}} className={classes.modalContent}>
              {status == "loading" && (
                <div className={classes.container}>
                  <LoadingView classes={{}} />
                </div>
              )}
              {status == "ready" && (template || {}).templateContents && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: template.templateContents,
                  }}
                />
              )}
            </DialogContent>
            <DialogActions>
              {this.props.handleCancel && (
                <Button
                  variant="contained"
                  onClick={this.handleCancel}
                  color="default"
                >
                  Cancel
                </Button>
              )}

              {this.props.handleComplete && (
                <Button
                  autoFocus={true}
                  onClick={this.handleComplete}
                  variant="contained"
                  color="secondary"
                >
                  {this.props.completeButtonText || "Complete"}
                </Button>
              )}
            </DialogActions>
          </Dialog>
        );
    }
  }
}

export default withStyles(styles)(TemplateDialogForm);
